import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'hooks';
import { DataLine, NameLabel } from 'components/elements';
import { dateUtils } from 'utils';

function ProfileHead() {
  const { t } = useTranslation('labels');
  const { user } = useAuth();

  return (
    <>
      <DataLine
        label={t('first_name')}
        body={<NameLabel firstName={user.firstName} personalPronoun={user.personalPronoun} options={{ pronoun: { parentheses: true, mutedText: true } }} />}
      />
      <DataLine label={t('last_name')} body={user.lastName} />
      <DataLine label={t('date_of_birth')} body={dateUtils.formatDateTimeString(user.birthDate)} />
    </>
  );
}

export default ProfileHead;
